(() => {
  if (!document.body) return;

  document.body.classList.remove('tt-page-booting', 'tt-pdp-booting');
  document.body.classList.add('tt-page-ready', 'tt-pdp-ready');

  const designMode = document.documentElement.classList.contains('shopify-design-mode');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const main = document.getElementById('MainContent');
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const progress = document.querySelector('.tt-nav-progress');

  const MEDIA_SEL = [
    '.tt-product-6011-hero__media',
    '.tt-product-6011-hero__thumb',
    '.tt-e300-pdp-featured__tile--image',
    '.tt-e300-pdp-featured__tile--video',
    '.tt-product-e300-benefits__media',
    '.tt-t600-base-tabs__media',
    '.tt-product-6011-sticky-atc__thumb',
    '.ff-popular-products__media',
    '.card__media',
    '.media',
    '.tt-e300-pdp-lightbox__frame',
    '.tt-product-6011-hero__lightbox-frame',
    '.tt-e300-ot__media',
    '.tt-f50-perf__media',
    '.tt-f50-help__media',
    '.tt-f50-fit__media',
    '.tt-f50-dims__media',
    '.tt-lift-fit-room__media',
    '.tt-e300-bt__media',
    '.tt-product-6011-lifestyle__media',
    '.tt-irl-gallery__media',
  ].join(',');

  const SKIP_CHROME = [
    'header',
    'sticky-header',
    '.header-wrapper',
    '.announcement-bar-section',
    '.tt-page-loader',
    '.list-payment',
    '.footer__payment',
    '.list-social',
    'model-viewer',
  ].join(',');

  const SKIP_HOST = [
    'main',
    'section',
    'body',
    '#MainContent',
    '.shopify-section',
    '.content-for-layout',
  ].join(',');

  const SMALL_MEDIA = [
    '.tt-product-6011-hero__thumb',
    '.tt-product-6011-sticky-atc__thumb',
  ].join(',');

  const LARGE_MEDIA = [
    '.tt-product-6011-hero__media',
    '.tt-e300-pdp-lightbox__frame',
    '.tt-product-6011-hero__lightbox-frame',
  ].join(',');

  const SKIP_PATH = /^\/(cart|checkout|account|orders|apps|admin|tools|password)(\/|$)/i;
  const NAV_KEY = 'tt-nav-pending';
  const MARK_HTML = '<span class="tt-loader-mark" aria-hidden="true"></span>';

  const pendingBinds = new WeakSet();

  const mediaParentOf = (el) => {
    if (!el || !el.closest) return null;
    const known = el.closest(MEDIA_SEL);
    if (known) return known;

    let node = el.parentElement;
    while (node && node !== document.body) {
      if (node.matches(SKIP_CHROME) || node.matches(SKIP_HOST)) return null;
      const w = node.clientWidth;
      const h = node.clientHeight;
      if (w >= 48 && h >= 48) return node;
      node = node.parentElement;
    }
    return null;
  };

  const setMediaLoading = (el, loading) => {
    if (!el) return;
    const media = el.matches && el.matches(MEDIA_SEL) ? el : mediaParentOf(el);
    if (!media) return;
    const in3d = Boolean(
      media.classList.contains('is-3d') ||
      media.classList.contains('is-3d-active') ||
      media.closest('.is-3d, .is-3d-active, .tt-e300-pdp-lightbox__3d, .tt-product-6011-hero__3d, model-viewer')
    );
    if (in3d || el.hidden) {
      loading = false;
    }
    if (loading && media.closest('.tt-product-6011-hero--lift-pdp')) {
      loading = false;
    }
    let layer = media.querySelector(':scope > .tt-media-loader');
    if (loading) {
      media.classList.add('tt-media-loading');
      if (!layer) {
        layer = document.createElement('span');
        layer.className = 'tt-media-loader';
        layer.setAttribute('aria-hidden', 'true');
        layer.innerHTML = MARK_HTML;
        const mark = layer.querySelector('.tt-loader-mark');
        if (mark && media.matches(SMALL_MEDIA)) mark.classList.add('tt-loader-mark--sm');
        if (mark && media.matches(LARGE_MEDIA)) mark.classList.add('tt-loader-mark--lg');
        media.appendChild(layer);
      }
      return;
    }
    media.classList.remove('tt-media-loading');
    if (layer) layer.remove();
  };

  const markImageReady = (img) => {
    if (
      !img ||
      img.classList.contains('tt-img-skip') ||
      img.classList.contains('tt-img-hover-card') ||
      img.classList.contains('tt-img-mask-icon')
    ) {
      setMediaLoading(img, false);
      return;
    }
    img.classList.add('tt-img-ready');
    img.classList.remove('tt-img-loading');
    setMediaLoading(img, false);
  };

  const hasImageSource = (img) => Boolean(img.getAttribute('src') || img.getAttribute('srcset'));

  const bindImage = (img) => {
    if (!img) return;
    if (img.dataset.ttImgBound === 'true') return;

    if (img.closest('.tt-e300-pdp-lightbox, .tt-product-6011-hero__lightbox')) {
      img.dataset.ttImgBound = 'true';
      const frame = img.closest('.tt-e300-pdp-lightbox__frame, .tt-product-6011-hero__lightbox-frame') || img;
      const lightbox = img.closest('.tt-e300-pdp-lightbox, .tt-product-6011-hero__lightbox');
      const mediaMode = Boolean(
        (frame && (frame.classList.contains('is-3d') || frame.classList.contains('is-video'))) ||
        (lightbox && (lightbox.classList.contains('is-3d') || lightbox.classList.contains('is-video')))
      );
      if (mediaMode) {
        setMediaLoading(frame, false);
        return;
      }
      if (!hasImageSource(img) || img.hidden) {
        setMediaLoading(frame, true);
        return;
      }
      const done = () => setMediaLoading(frame, false);
      if (img.complete && img.naturalWidth) {
        done();
        return;
      }
      setMediaLoading(frame, true);
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      return;
    }

    if (img.classList.contains('tt-img-skip')) {
      img.classList.add('tt-img-skip');
      img.dataset.ttImgBound = 'true';
      return;
    }

    if (img.classList.contains('tt-product-6011-hero__main-img')) {
      img.classList.add('tt-img-ready');
      img.classList.remove('tt-img-loading');
      img.dataset.ttImgBound = 'true';
      setMediaLoading(img, false);
      return;
    }

    if (img.closest(SKIP_CHROME)) {
      img.classList.add('tt-img-skip');
      img.dataset.ttImgBound = 'true';
      return;
    }

    if (img.closest('.tt-product-6011-hero--lift-pdp')) {
      img.classList.add('tt-img-skip', 'tt-img-ready');
      img.classList.remove('tt-img-loading');
      img.dataset.ttImgBound = 'true';
      setMediaLoading(img, false);
      return;
    }

    if (img.classList.contains('tt-img-mask-icon') || img.classList.contains('tt-t600-base-tabs__icon-image')) {
      img.classList.add('tt-img-mask-icon');
      img.classList.remove('tt-img-ready', 'tt-img-skip', 'tt-img-loading', 'tt-img-el');
      img.dataset.ttImgBound = 'true';
      return;
    }

    const isPopularImage = img.classList.contains('ff-popular-products__image');
    const hoverMedia = img.closest('.media--hover-effect');
    const isHoverCard = isPopularImage || hoverMedia;
    const isSecondary =
      img.classList.contains('ff-popular-products__image--secondary') ||
      (hoverMedia && img.previousElementSibling && img.previousElementSibling.tagName === 'IMG');

    if (isHoverCard) {
      img.classList.add('tt-img-hover-card');
      img.classList.remove('tt-img-ready', 'tt-img-skip', 'tt-img-loading', 'tt-img-el');
      img.dataset.ttImgBound = 'true';
      if (isSecondary) {
        img.classList.add('tt-img-hover-secondary');
        return;
      }
      if (img.complete) {
        setMediaLoading(img, false);
        return;
      }
      setMediaLoading(img, true);
      const doneHover = () => setMediaLoading(img, false);
      img.addEventListener('load', doneHover, { once: true });
      img.addEventListener('error', doneHover, { once: true });
      return;
    }

    if (img.classList.contains('tt-img-skip') || img.hasAttribute('data-tt-hero-lqip')) {
      img.classList.add('tt-img-skip');
      img.dataset.ttImgBound = 'true';
      return;
    }

    if (
      img.closest('.banner__media') ||
      img.classList.contains('tami-hero-frame-image') ||
      img.classList.contains('tt-collection-banner__image')
    ) {
      img.classList.add('tt-img-skip');
      img.dataset.ttImgBound = 'true';
      return;
    }

    img.dataset.ttImgBound = 'true';

    if (!hasImageSource(img) || img.hidden) {
      img.classList.remove('tt-img-loading', 'tt-img-ready');
      setMediaLoading(img, false);
      return;
    }

    if (img.complete && img.naturalWidth) {
      markImageReady(img);
      return;
    }

    img.classList.add('tt-img-loading');
    img.classList.remove('tt-img-ready');
    setMediaLoading(img, true);
    const done = () => markImageReady(img);
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
    window.setTimeout(() => {
      if (img.classList.contains('tt-img-loading')) markImageReady(img);
    }, 8000);
  };

  const rebindImage = (img) => {
    if (!img || pendingBinds.has(img)) return;
    pendingBinds.add(img);
    window.requestAnimationFrame(() => {
      pendingBinds.delete(img);
      img.dataset.ttImgBound = 'false';
      img.classList.remove('tt-img-ready');
      bindImage(img);
    });
  };

  const bindMediaEl = (el) => {
    if (!el || el.dataset.ttMediaBound === 'true') return;
    if (el.closest('model-viewer')) return;
    el.dataset.ttMediaBound = 'true';

    if (el.tagName === 'VIDEO') {
      if (el.readyState >= 2) {
        setMediaLoading(el, false);
        return;
      }
      setMediaLoading(el, true);
      const done = () => setMediaLoading(el, false);
      el.addEventListener('loadeddata', done, { once: true });
      el.addEventListener('error', done, { once: true });
      window.setTimeout(done, 8000);
      return;
    }

    if (el.tagName === 'IFRAME') {
      setMediaLoading(el, true);
      const done = () => setMediaLoading(el, false);
      el.addEventListener('load', done, { once: true });
      el.addEventListener('error', done, { once: true });
      window.setTimeout(done, 6000);
    }
  };

  const bindAllImages = (root) => {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('img').forEach(bindImage);
    root
      .querySelectorAll('video, iframe')
      .forEach((el) => {
        if (el.closest(SKIP_CHROME)) return;
        if (el.closest('model-viewer, predictive-search, cart-drawer')) return;
        bindMediaEl(el);
      });
  };

  const onIdle = (fn, timeout) => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout });
    else window.setTimeout(fn, Math.min(timeout, 400));
  };

  const preloadSecondary = () => {
    const thumbs = Array.from(document.querySelectorAll('[data-tt-hero-thumb]'));
    thumbs.slice(0, isMobile ? 3 : 5).forEach((thumb) => {
      const url = isMobile
        ? thumb.getAttribute('data-src-mobile') || thumb.getAttribute('data-full')
        : thumb.getAttribute('data-full');
      if (!url) return;
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = url;
      link.setAttribute('fetchpriority', 'low');
      document.head.appendChild(link);
    });
  };

  const toSameOriginUrl = (href) => {
    if (!href || href.charAt(0) === '#') return null;
    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }
    if (url.origin !== window.location.origin) return null;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    if (SKIP_PATH.test(url.pathname)) return null;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return null;
    return url;
  };

  const shouldLeave = (anchor, event) => {
    if (!anchor || reduceMotion || designMode) return false;
    if (document.documentElement.getAttribute('data-tt-block-nav') === '1') return false;
    if (document.body.classList.contains('tt-product-6011-hero--zoom-open')) return false;
    if (anchor.closest('.tt-e300-pdp-lightbox, .tt-product-6011-hero__lightbox, .tt-e300-pdp-lightbox__nav, .tt-pdp-sheet__nav')) return false;
    if (
      event.target
      && event.target.closest
      && event.target.closest('[data-tt-e300-image-tile], [data-tt-e300-gallery-scroller], [data-tt-hero-media], .tt-e300-pdp-featured')
    ) {
      return false;
    }
    if (event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.target === '_blank' || anchor.hasAttribute('download')) return false;
    if (anchor.id === 'cart-icon-bubble') return false;
    if (anchor.closest('cart-drawer, .cart-drawer, predictive-search')) return false;
    if (anchor.hasAttribute('data-tt-no-loader')) return false;
    const href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return false;
    return Boolean(toSameOriginUrl(href));
  };

  const startLeave = () => {
    try {
      sessionStorage.setItem(NAV_KEY, '1');
    } catch (error) {
      /* ignore quota / private mode */
    }
    if (progress) progress.classList.remove('is-done');
    document.documentElement.classList.add('tt-page-leaving');
  };

  let pageRevealed = false;
  const revealPageContent = () => {
    if (pageRevealed || !main || reduceMotion || designMode) return;
    pageRevealed = true;
    const fadeUp = (element, delay = 0) => {
      if (!element || element.dataset.ttMotionReady) return;
      element.dataset.ttMotionReady = 'true';
      element.animate(
        [{ opacity: .01, transform: 'translateY(40px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 500, delay, easing: 'cubic-bezier(0, 0, .3, 1)', fill: 'backwards' }
      );
    };
    const hero = main.querySelector('section[id$="__image_banner"]');
    if (hero && window.scrollY < hero.offsetTop + hero.offsetHeight) {
      const activeSlide = hero.dataset.tamiHeroSlide || '0';
      const panel = hero.querySelector(`[data-tami-hero-slide="${activeSlide}"].tami-hero-slide__panel`);
      const media = hero.querySelector(`.tami-hero-media-layer[data-tami-hero-layer="${activeSlide}"]`)
        || hero.querySelector('.tami-hero-carousel__media, .banner__media');
      if (media) {
        media.dataset.ttMotionReady = 'true';
        media.animate([{ scale: '1.3' }, { scale: '1' }], {
          duration: 1500, easing: 'cubic-bezier(0, 0, .3, 1)'
        });
      }
      if (panel) {
        fadeUp(panel.querySelector('.tami-hero-eyebrow'), 250);
        fadeUp(panel.querySelector('.banner__heading'), 350);
        fadeUp(panel.querySelector('.banner__text'), 450);
        fadeUp(panel.querySelector('.banner__buttons'), 550);
      }
    }
    if (!('IntersectionObserver' in window)) return;
    const cardSelector = '.tt-bed-card, .ff-blog-center__card, .ff-category-entry__card, .ff-popular-products__card, .card-wrapper';
    const waitForCardImage = (image) => new Promise((resolve) => {
      if (!image || image.complete) { resolve(); return; }
      let timer;
      const done = () => {
        image.removeEventListener('load', done);
        image.removeEventListener('error', done);
        window.clearTimeout(timer);
        resolve();
      };
      image.addEventListener('load', done, { once: true });
      image.addEventListener('error', done, { once: true });
      timer = window.setTimeout(done, 4000);
    });
    const cardObserver = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting && entry.intersectionRatio > 0)
        .sort((a, b) => Math.abs(a.boundingClientRect.top - b.boundingClientRect.top) > 20
          ? a.boundingClientRect.top - b.boundingClientRect.top
          : a.boundingClientRect.left - b.boundingClientRect.left);
      visible.forEach(async (entry, index) => {
        const card = entry.target;
        if (!card.dataset.ttMotionReady) {
          card.dataset.ttMotionReady = 'true';
          const image = card.querySelector('img:not(.tt-img-mask-icon)');
          await waitForCardImage(image);
          if (!card.isConnected) return;
          const delay = 50 + Math.min(index, 5) * 100;
          if (image && image.naturalWidth > 0) {
            image.dataset.ttMotionReady = 'true';
            image.animate([{ scale: '1.1' }, { scale: '1' }], {
              duration: 1000, delay, easing: 'cubic-bezier(0, 0, .3, 1)', fill: 'backwards'
            });
          }
          const copy = card.querySelector('.tt-bed-card__details, .card__information');
          if (copy) {
            fadeUp(copy, delay);
          } else {
            card.querySelectorAll('h2, h3, p').forEach((text, textIndex) => {
              fadeUp(text, delay + textIndex * 100);
            });
          }
        }
        cardObserver.unobserve(card);
      });
    }, { threshold: .05, rootMargin: '0px 0px -50px 0px' });
    main.querySelectorAll(cardSelector).forEach((card) => {
      if (!card.parentElement.closest(cardSelector)) cardObserver.observe(card);
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const section = entry.target;
        // Animate a content wrapper, leaving section geometry and sticky elements stable.
        if (!section.querySelector('[style*="position: sticky"], .product__info-container, .tt-product-6011-hero')) {
          const content = Array.from(section.children).find((child) =>
            !child.matches('style, script, link, template')
          );
          if (!section.querySelector(cardSelector)) {
            fadeUp(content, 100);
          }
        }
        observer.unobserve(section);
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    Array.from(main.children).forEach((section) => {
      if (!section.matches('.shopify-section') || section === hero) return;
      if (section.getBoundingClientRect().top < window.innerHeight) return;
      observer.observe(section);
    });
    window.addEventListener('pagehide', () => {
      observer.disconnect();
      cardObserver.disconnect();
    }, { once: true });
  };
  const finishEnter = () => {
    if (progress) progress.classList.add('is-done');
    document.documentElement.classList.remove('tt-page-entering', 'tt-page-leaving');
    window.requestAnimationFrame(revealPageContent);
    try {
      sessionStorage.removeItem(NAV_KEY);
    } catch (error) {
      /* ignore */
    }
  };

  const bindPageLoader = () => {
    if (designMode || reduceMotion) {
      finishEnter();
      return;
    }

    document.addEventListener(
      'click',
      (event) => {
        if (
          event.target
          && event.target.closest
          && event.target.closest('button, .tt-e300-pdp-lightbox, .tt-product-6011-hero__lightbox, [data-tt-e300-image-tile], [data-tt-e300-gallery-scroller], [data-tt-hero-media], .tt-e300-pdp-featured')
        ) {
          return;
        }
        const inLightbox = Boolean(
          document.body.classList.contains('tt-product-6011-hero--zoom-open')
          || document.documentElement.getAttribute('data-tt-block-nav') === '1'
        );
        const anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        if (inLightbox && anchor && !anchor.closest('.tt-e300-pdp-lightbox, .tt-product-6011-hero__lightbox')) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          return;
        }
        if (!shouldLeave(anchor, event)) return;
        startLeave();
      },
      true
    );

    window.addEventListener('pageshow', (event) => {
      document.documentElement.classList.remove('tt-page-leaving');
      if (event.persisted) finishEnter();
    });

    if (!document.documentElement.classList.contains('tt-page-entering')) {
      finishEnter();
      return;
    }

    const hide = () => window.requestAnimationFrame(finishEnter);

    if (document.readyState !== 'loading') hide();
    else window.addEventListener('DOMContentLoaded', hide, { once: true });
    window.setTimeout(finishEnter, 900);
  };

  const warmBelowHero = () => {
    if (!document.body.classList.contains('template-product')) return;
    const hero = document.querySelector('[data-tt-hero-main]');
    if (!hero || hero.tagName !== 'IMG') return;

    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const effectiveType = conn && conn.effectiveType ? conn.effectiveType : '';
    if (conn && (conn.saveData || effectiveType === 'slow-2g' || effectiveType === '2g')) return;

    const allowVideo = !conn || (effectiveType !== '3g' && effectiveType !== '2g' && effectiveType !== 'slow-2g');
    const root = main || document.getElementById('MainContent');
    if (!root) return;

    const heroSection = hero.closest('.shopify-section') || hero.parentElement;
    const docTop = (el) => el.getBoundingClientRect().top + window.scrollY;
    const MAX_IMAGES = 2;
    let imageSlots = 0;
    let activeVideo = null;
    let heroReady = hero.complete && hero.naturalWidth > 0;
    let pumping = false;

    const skipImage = (img) => {
      if (!img || img.dataset.ttBelowWarm === '1') return true;
      if (img.closest('[data-tt-hero-thumb], .tt-e300-pdp-lightbox, .tt-product-6011-hero__lightbox, [hidden]')) return true;
      if (img.hidden || img.classList.contains('tt-img-mask-icon')) return true;
      if (!hasImageSource(img)) return true;
      if (img.complete && img.naturalWidth) return true;
      const box = img.getBoundingClientRect();
      if (box.width > 0 && box.width < 96 && box.height > 0 && box.height < 96) return true;
      return false;
    };

    const inLookahead = (el) => {
      const top = docTop(el);
      const viewBottom = window.scrollY + window.innerHeight;
      const heroBottom = heroSection
        ? heroSection.getBoundingClientRect().bottom + window.scrollY
        : viewBottom;
      const limit = Math.max(viewBottom, heroBottom) + window.innerHeight;
      return top < limit && top + (el.offsetHeight || 0) > window.scrollY - 40;
    };

    const pump = () => {
      if (!heroReady || pumping) return;
      pumping = true;
      const images = Array.from(root.querySelectorAll('img'))
        .filter((img) => !skipImage(img) && inLookahead(img))
        .sort((a, b) => docTop(a) - docTop(b));

      while (imageSlots < MAX_IMAGES && images.length) {
        const img = images.shift();
        img.dataset.ttBelowWarm = '1';
        if ('fetchPriority' in img) img.fetchPriority = 'low';
        img.loading = 'eager';
        if (img.complete && img.naturalWidth) continue;
        imageSlots += 1;
        let released = false;
        const release = () => {
          if (released) return;
          released = true;
          imageSlots -= 1;
          pumping = false;
          pump();
        };
        img.addEventListener('load', release, { once: true });
        img.addEventListener('error', release, { once: true });
        window.setTimeout(release, 8000);
      }
      pumping = false;

      if (!allowVideo) return;
      const videoStillBuffering =
        activeVideo &&
        activeVideo.readyState < 3 &&
        docTop(activeVideo) + (activeVideo.offsetHeight || 0) > window.scrollY;
      if (videoStillBuffering) return;

      const video = Array.from(root.querySelectorAll('video.tt-product-e300-benefits__video'))
        .filter((node) => {
          if (node.dataset.ttBelowWarm === '1') return false;
          if (node.closest('[hidden]')) return false;
          if (!(node.muted && node.loop && !node.controls)) return false;
          return Boolean(node.currentSrc || node.getAttribute('src') || node.querySelector('source[src]'));
        })
        .sort((a, b) => docTop(a) - docTop(b))[0];
      if (!video) return;

      video.dataset.ttBelowWarm = '1';
      activeVideo = video;
      video.removeAttribute('loading');
      if ('fetchPriority' in video) video.fetchPriority = 'low';
      video.muted = true;
      video.autoplay = true;
      video.preload = 'auto';
      if (video.readyState < 2) {
        try {
          video.load();
        } catch (error) {
          /* ignore */
        }
      }
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
      const advance = () => {
        if (activeVideo === video) pump();
      };
      if (video.readyState >= 3) {
        window.setTimeout(advance, 0);
      } else {
        video.addEventListener('canplay', advance, { once: true });
        video.addEventListener('error', () => {
          if (activeVideo === video) activeVideo = null;
          pump();
        }, { once: true });
      }
    };

    const kick = () => {
      heroReady = true;
      pump();
    };
    if (hero.complete && hero.naturalWidth) kick();
    else {
      hero.addEventListener('load', kick, { once: true });
      hero.addEventListener('error', kick, { once: true });
    }

    let timer = 0;
    window.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(pump, 160);
      },
      { passive: true }
    );
  };

  bindPageLoader();

  if (designMode) return;
  // Reviews use native image loading. Do not observe every card/filter mutation
  // with the product media shell; retain the shared navigation loader above.
  if (/\/pages\/reviews\/?$/.test(location.pathname) && document.querySelector('[data-stories-gallery], [data-story-topic]')) return;

  document.documentElement.classList.add('tt-img-loader');
  bindAllImages(document);
  onIdle(preloadSecondary, isMobile ? 900 : 500);
  warmBelowHero();

  if (main) {
    window.setTimeout(() => {
      main
        .querySelectorAll('img:not(.tt-img-ready):not(.tt-img-skip):not(.tt-img-hover-card):not(.tt-img-mask-icon)')
        .forEach(markImageReady);
      main.querySelectorAll('.tt-media-loading').forEach((node) => {
        if (node.closest('.tt-e300-pdp-lightbox, .tt-product-6011-hero__lightbox')) return;
        node.classList.remove('tt-media-loading');
        const leftover = node.querySelector(':scope > .tt-media-loader');
        if (leftover) leftover.remove();
      });
    }, 1800);
  }

  if ('MutationObserver' in window) {
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.target.tagName === 'IMG') {
          const img = mutation.target;
          if (
            img.classList.contains('tt-img-hover-card') ||
            img.classList.contains('tt-img-skip') ||
            img.classList.contains('tt-img-mask-icon') ||
            img.closest('.is-3d, .is-3d-active, .tt-e300-pdp-lightbox__3d, .tt-product-6011-hero__3d, model-viewer') ||
            img.closest('.tt-product-6011-hero--lift-pdp') ||
            (
              document.documentElement.getAttribute('data-tt-block-nav') === '1'
              && img.closest('[data-tt-e300-gallery-scroller], [data-tt-hero-media], .tt-e300-pdp-featured, .tt-product-6011-hero')
            )
          ) {
            return;
          }
          rebindImage(img);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') bindImage(node);
          else if (node.tagName === 'VIDEO' || node.tagName === 'IFRAME') bindMediaEl(node);
          else if (node.querySelectorAll) bindAllImages(node);
        });
      });
    });
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'hidden'],
    });
  }

  window.TTSiteLoader = {
    bindImage,
    bindRoot: bindAllImages,
    setMediaLoading,
  };
})();
